module.exports = __webpack_public_path__ + "static/media/forklift.86b1f4dc.svg";